import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 4,
  title: "Your Toddler's Skin Barrier Isn't Fully Developed (3-5x More Vulnerable)",
  titleImages: [{
    url: 'https://cdn.magicpatterns.com/uploads/8CMTQGhhtur5TTWgwGr4tf/unnamed_(6).jpg',
    alt: 'Skin structure comparison diagram showing toddler skin (3-4 years) with thinner stratum corneum and sparser microbiome versus adult skin (35-40 years) with thicker layers and dense microbiome'
  }],
  mechanism: <>
      Young children's skin has a <strong data-id="element-110">thinner outer layer</strong> (stratum
      corneum) and an <strong data-id="element-111">underdeveloped acid mantle</strong> compared to
      adult skin. The same chlorine concentration that might cause minor
      irritation in adults cause <strong data-id="element-112">significant flare-ups</strong> in
      toddlers.
    </>,
  avatars: {},
  bridge: <>
      Creams can soothe irritation, but they <strong data-id="element-113">can't compensate</strong>{' '}
      for developmental skin barrier immaturity against{' '}
      <strong data-id="element-114">chemical exposure</strong>.
    </>,
  imageOnLeft: false
};
export function Item5Section() {
  return <ItemSection data={data} data-id="element-115" />;
}